/* eslint import/namespace: 0 */
import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';
import { useMemo } from 'react';
import * as actions from '../actions/property';

export const usePropertyActions = deps => {
  const dispatch = useDispatch();
  return useMemo(
    () =>
      Object.keys(actions).reduce(
        (acc, key) => ({
          ...acc,
          [key]:
            typeof actions[key] !== 'string'
              ? bindActionCreators(actions[key], dispatch)
              : null,
        }),
        {},
      ),
    deps ? [dispatch, ...deps] : deps,
  );
};
